import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "system-list text-[30px]" }
const _hoisted_2 = { class: "systemName inline-block font-bold" }
const _hoisted_3 = { class: "mb-2" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 0 }

import { ref, computed, onMounted, watch, nextTick } from 'vue';
import { RectDown } from '@nutui/icons-vue-taro';
import attachment from '@/pages/equipmentLifecycle/components/attachment.vue';
import { getBaseSystemList } from '@/service/base';
import { useUserStore } from '@/stores/user';

export default /*@__PURE__*/_defineComponent({
  ...{ name: 'systemList' },
  __name: 'systemList',
  props: /*@__PURE__*/_mergeModels({
    mode: { default: 'view' }
  }, {
    "modelValue": {
  default: () => [
    {
      systemName: '',
      equipElectronices: [],
      recordElectronices: [],
    },
  ],
},
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props: any) {

const userStore = useUserStore();

const props = __props;

// 使用 defineModel 实现 v-model 双向绑定
const systemListData = _useModel<Record<string, any>[]>(__props, "modelValue");
const systemActiveNames = ref<string[]>([]);

// 标记是否已经初始化过
const hasInitialized = ref(false);

// 监听 systemListData 变化，更新 systemActiveNames
watch(
  systemListData,
  newData => {
    console.log('systemListData 变化:', newData);
    if (newData && Array.isArray(newData)) {
      systemActiveNames.value = newData
        .filter(item => item.systemName)
        .map(item => item.systemName);
    } else {
      systemActiveNames.value = [];
    }
    console.log('更新后的systemActiveNames:', systemActiveNames.value);

    // 如果是 upload 模式且还未初始化，且没有有效数据，才获取系统列表
    if (props.mode === 'upload' && !hasInitialized.value) {
      hasInitialized.value = true;
      // 延迟检查，给父组件数据恢复留出时间
      setTimeout(async () => {
        // 再次检查是否有有效数据，如果没有才获取
        if (
          !systemListData.value ||
          systemListData.value.length === 0 ||
          !systemListData.value.some(item => item.systemName)
        ) {
          console.log('没有有效的缓存数据，开始获取系统列表');
          await initializeSystemList();
        } else {
          console.log('检测到有效的缓存数据，跳过获取系统列表');
        }
      }, 300); // 增加延迟时间，确保父组件数据恢复完成
    }
  },
  { immediate: true, deep: true }
);

const currentBase: any = computed(() => userStore.getCurrentBase);

const getSystemList = async () => {
  try {
    const { data } = await getBaseSystemList(currentBase.value.baseId);
    systemListData.value = data.map((item: any) => ({
      ...item,
      equipElectronices:
        props.mode === 'upload'
          ? item.equipElectronices || []
          : item.equipElectronices || [],
      recordElectronices:
        props.mode === 'upload'
          ? item.recordElectronices || []
          : item.recordElectronices || [],
    }));
    console.log('系统列表', data);
  } catch (err) {}
};

// 延迟初始化，等待父组件数据恢复
const initializeSystemList = async () => {
  if (props.mode === 'upload') {
    console.log('initializeSystemList - systemListData:', systemListData.value);
    // 只有在没有数据时才获取系统列表，避免覆盖暂存数据
    const hasValidData =
      systemListData.value &&
      systemListData.value.length > 0 &&
      systemListData.value.some(item => item.systemName);

    if (!hasValidData) {
      console.log('获取系统列表数据');
      await getSystemList();
    } else {
      console.log('使用已有的暂存数据，跳过重新获取');
    }
  }
};

onMounted(() => {
  // 初始化逻辑已移至 watch 监听器中，确保在数据变化时正确处理
  console.log('systemList 组件已挂载');
});



return (_ctx: any,_cache: any) => {
  const _component_nut_collapse_item = _resolveComponent("nut-collapse-item")!
  const _component_nut_collapse = _resolveComponent("nut-collapse")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[1] || (_cache[1] = _createElementVNode("h4", { class: "mt-4 mb-2" }, "设备运行 & 交班记录", -1)),
    _createVNode(_component_nut_collapse, {
      modelValue: systemActiveNames.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((systemActiveNames).value = $event))
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(systemListData.value, (item, idx) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "system-item mb-2 border-1 border-solid border-[#eee]",
            key: idx
          }, [
            _createVNode(_component_nut_collapse_item, {
              name: item.systemName || '--'
            }, {
              icon: _withCtx(() => [
                _createVNode(_unref(RectDown))
              ]),
              title: _withCtx(() => [
                _createElementVNode("span", _hoisted_2, _toDisplayString(item.systemName || '--'), 1)
              ]),
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                  (!props.mode || props.mode !== 'upload')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_4, "设备运行确认表"))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", {
                    class: _normalizeClass(`${
                !props.mode || props.mode !== 'upload'
                  ? 'translate-x-[-20rpx]'
                  : ''
              }`)
                  }, [
                    _createVNode(attachment, {
                      files: item.equipElectronices,
                      "onUpdate:files": ($event: any) => ((item.equipElectronices) = $event),
                      imageOnly: "",
                      accept: "image/*",
                      maxCount: 2,
                      mode: props.mode,
                      labelWidth: '115px',
                      label: "设备运行确认表"
                    }, null, 8, ["files", "onUpdate:files", "mode"])
                  ], 2)
                ]),
                _createElementVNode("div", null, [
                  (!props.mode || props.mode !== 'upload')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_5, "交班记录表"))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", {
                    class: _normalizeClass(`${
                !props.mode || props.mode !== 'upload'
                  ? 'translate-x-[-20rpx]'
                  : ''
              }`)
                  }, [
                    _createVNode(attachment, {
                      files: item.recordElectronices,
                      "onUpdate:files": ($event: any) => ((item.recordElectronices) = $event),
                      imageOnly: "",
                      accept: "image/*",
                      maxCount: 2,
                      mode: props.mode,
                      labelWidth: '115px',
                      label: "交班记录表"
                    }, null, 8, ["files", "onUpdate:files", "mode"])
                  ], 2)
                ])
              ]),
              _: 2
            }, 1032, ["name"])
          ]))
        }), 128))
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})